/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import CustomSelect from '../../../Form/Select';

export function DropDown({ data, setData, setError, ind, isRequired, globalStateData }) {
  const [selectedValue, setSelectedValue] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue ?? '',
  );

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  useEffect(() => {
    setError(null);

    if (isRequired && (selectedValue === '' || selectedValue === null)) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }

    setData(selectedValue, ind);
  }, [selectedValue]);

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <CustomSelect
          {...{
            labelText: data?.fieldName,
            isRequired,
            options: data?.dropDownOptions || [],
            defaultValue: selectedValue || '',
            getTitle: (value) => value,
            labelFor: data?.fieldName,
            fieldName: data?.fieldName,
            onChangeHandler: setSelectedValue,
            disabled: isDisabled,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default DropDown;
